import { AppBloc } from "@/services/base-bloc";
import { useContext } from "react";
import { AppContext } from "./AppContext";

export const useAppBloc = () => {
  const appBloc = useContext<AppBloc>(AppContext);
  return { appBloc };
};
